import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import WrapperList from "../../../Nano/WrapperList.js";
import TitleCard from "../../../Nano/TitleCard.js";
import Article from "../../../Nano/Article.js";

const StyledEnvironmentBlock = styled(NanoFlex)`
  .noBorderWrapper {
    border: none;
    padding: 0;
  }
  .titleWrapper {
    h5 {
      width: 100%;
    }
  }
`;

export class EnvironmentBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    if (!this.props.card.environment || this.props.card.environment.trim() === "") return null;

    return (
      <StyledEnvironmentBlock className="rowContainer enviromentBlock">
        <WrapperList simple className="noBorderWrapper enviromentWrapper">
          <TitleCard simpleTitle={this.translation.card.environment} />
          <Article article={this.props.card.environment} />
        </WrapperList>
      </StyledEnvironmentBlock>
    );
  }
}

//Set default props
EnvironmentBlock.defaultProps = {
  card: {},
};

export default EnvironmentBlock;

// --- // Documentation // --- //
/*
  import EnvironmentBlock from './../Partial/EnvironmentBlock.js';
  
  <EnvironmentBlock/>
  */
